<template>
    <div>
        <div class="page-wrapper">
            <!-- start header -->
            <router-view name="topheader"></router-view>
            <!-- end header -->

            <!-- start page container -->
            <div class="page-container">
                <!-- start sidebar menu -->
                <router-view name="sidebar"></router-view>
                <!-- end sidebar menu -->
                <!-- start page content -->
                <div class="page-content-wrapper">
                    <div class="page-content">
                        <!-- START content_Abtg -->
                        <transition name="fade" mode="out-in">
                            <router-view  ></router-view>
                        </transition>

                        <!-- END content_Abtg -->
                    </div>
                </div>
                <!-- end page content -->
                <!-- start chat sidebar -->

                <!-- end chat sidebar -->
            </div>
            <!-- end page container -->
            <!-- start footer -->
            <div class="page-footer  ">
                <router-view name="footer"></router-view>
            </div>
            <!-- end footer -->
          
          <!-- floating contact form -->
            <floating-form></floating-form>
          <!-- end floating -->
        </div>
    </div>
</template>
<script>
    import FloatingForm from "./partials/floatingForm";
    export default {
      components: {FloatingForm}
    }
</script>
